import { render, staticRenderFns } from "./DefectReportStatusSelect.vue?vue&type=template&id=2ae0d54c&"
import script from "./DefectReportStatusSelect.vue?vue&type=script&lang=js&"
export * from "./DefectReportStatusSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports